module.exports = __webpack_public_path__ + "static/gallery11-dcb2ac54d11be186378fef898bc633b9.jpg";